import React, { useLayoutEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Carousel, Section } from '../../components';
import { projects } from './config';
import './Projects.scss'

const Projects = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname])

    const items = projects?.map((project) =>
        <div className='projects_item' key={project?.id}>
            <div className='projects_content_name'>{project.name}</div>
            <div className='projects_container'>
                <div className='projects_content'>
                    <Link
                        to={project.url}
                        style={{ textDecoration: 'none' }}
                    >
                        <img
                            src={project.img}
                            className='projects_content_img'
                            alt='prototypes img cover'
                        />
                        <h1 className='projects_content_description'>{project.duration}</h1>
                        <p className='projects_content_description'>{project.description}</p>
                    </Link>
                </div>
            </div>
        </div>
    );

    return (
        <Section
            title='Projects'
        >
            <div className='projects_display'>
                <Carousel
                    items={items}
                    arrows
                    showMarkers
                />
            </div>
        </Section>
    )
}

export default Projects;